import "./constants.mjs";
//#region src/components/layouts/JustifiedGallery/utils.ts
function e(e) {
	return e.aspectRatio || 1.77777;
}
function t(t, n) {
	return {
		item: t,
		index: n,
		aspectRatio: e(t)
	};
}
function n(e) {
	return {
		flexGrow: e,
		aspectRatio: e.toString()
	};
}
function r(e, t) {
	return `${e}px ${t}px`;
}
//#endregion
export { r as getGapStyle, t as getItemRenderData, n as getItemStyleProps, e as getSafeAspectRatio };
